import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ThemeProvider as EmotionThemeProvider, Global, css, useTheme as useEmotionTheme } from '@emotion/react';
import { createContext, useContext } from 'react';
const greenDark = {
    typography: {
        h1: { fontFamily: 'SurtExpanded', fontSize: 56, margin: 0 },
        h2: { fontFamily: 'SurtExpanded', fontSize: 32, margin: 0 },
        h3: { fontFamily: 'SurtExpanded', fontSize: 24, margin: 0 },
        h4: { fontFamily: 'SurtExpanded', fontSize: 18, margin: 0 },
        bodyLarge: { fontFamily: 'Surt', fontSize: 16, fontWeight: 'normal', margin: 0 },
        body: { fontFamily: 'Surt', fontSize: 14, fontWeight: 'normal', margin: 0 },
        bodySmall: { fontFamily: 'Surt', fontSize: 12, fontWeight: 'normal', margin: 0 },
    },
    color: {
        primary: '#d5ff5c',
        onPrimary: '#121212',
        primaryContainer: '#d5ff5c',
        onPrimaryContainer: '#121212',
        background: '#121212',
        onBackground: '#fafafa',
        surface: '#1b1b1b',
        onSurface: '#fafafa',
        surfaceTint: '#fafafa',
        error: '#d22424',
        onError: '#fafafa',
        errorContainer: '#fd48483e',
        onErrorContainer: '#d22424',
        outline: '#fafafa',
        outlineVariant: '#2f2f2f',
    },
    contentAlpha: {
        disabled: 0.5,
        medium: 0.7,
        high: 1,
    },
    shape: {
        none: 0,
        extraSmall: '0.4rem',
        small: '0.8rem',
        medium: '1.2rem',
        large: '1.6rem',
        extraLarge: '2.8rem',
        full: '100dvw',
    },
};
export const theme = { greenDark };
export const useTheme = useEmotionTheme;
const ThemeHasRootContext = createContext(false);
export const ThemeProvider = ({ theme: propsTheme = greenDark, merge = false, children }) => {
    const hasRoot = useContext(ThemeHasRootContext);
    const parentTheme = useEmotionTheme();
    const theme = !merge
        ? propsTheme
        : {
            typography: { ...parentTheme.typography, ...propsTheme.typography },
            color: { ...parentTheme.color, ...propsTheme.color },
            contentAlpha: { ...parentTheme.contentAlpha, ...propsTheme.contentAlpha },
            shape: { ...parentTheme.shape, ...propsTheme.shape },
        };
    return (_jsxs(_Fragment, { children: [!hasRoot && theme.color !== undefined && theme.typography !== undefined && (_jsx(Global, { styles: css `
            :root {
              color: ${theme.color.onBackground};
              font-family: ${theme.typography.body.fontFamily};
              font-size: 10px;
              font-weight: ${theme.typography.body.fontWeight ?? 'revert'};
              background-color: ${theme.color.background};
            }

            body {
              font-size: ${theme.typography.body.fontSize}px;
            }
          ` })), hasRoot ? (_jsx(EmotionThemeProvider, { theme: theme, children: children })) : (_jsx(ThemeHasRootContext.Provider, { value: true, children: _jsx(EmotionThemeProvider, { theme: theme, children: children }) }))] }));
};
//# sourceMappingURL=theme.js.map